import createIsInvalid from '../selectors/isInvalid';
import immutable from '../structure/immutable';

export default createIsInvalid(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/isInvalid.js
// module id = 1206
// module chunks = 0